import { setLOBTeamAgentDataByLobTeam, setLobTeamDataByLob } from 'store/ScoreCardFilter';

import { setFieldsData } from 'store/ScoreCardFilter';
import * as EvalutionFilter from 'store/EvaluationFilter';
import * as AnalyticsFilter from 'store/AnalyticsFilter';
import * as CallFlow from 'store/Settings/Tabs/CallFlow';
import * as AnalyzeFilter from 'store/InspectFilter';
import * as DashbordFilter from 'store/DashbordFilter';
import { WSS_EVENTS_FOR_QP } from 'socket.io';

function selectedLobTeamByLob(data, LobTeam) {
  const selectedLOB = data.filter((item) => item?.value === true).map((item) => item.id);

  const selectedTeam = [];
  try {
    const TEAMS = LobTeam;
    TEAMS.forEach((_ele) => {
      if (selectedLOB.includes(_ele.lob)) {
        selectedTeam.push(_ele);
      }
    });
  } catch (error) {
    console.error(error);
  }
  console.log(selectedTeam, 'selectedTeam');
  return selectedTeam;
}
function selectedLobTeamByLobCallflow(data, LobTeam) {
  const selectedLOB = data.filter((item) => item?.status === true).map((item) => item.id);
  const selectedTeam = [];
  try {
    const TEAMS = LobTeam;
    TEAMS.forEach((_ele) => {
      if (selectedLOB.includes(_ele.lob.id)) {
        selectedTeam.push(_ele);
      }
    });
  } catch (error) {
    console.error(error);
  }
  return selectedTeam;
}

function checkAvailability(arr, val) {
  return arr.some(function (arrVal) {
    // console.log(val, arrVal, val.includes(arrVal));
    return val.findIndex((_el) => _el.id === arrVal) > -1;
  });
}

function selectedLobTeamByLobTeam(data, LobTeamAgent) {
  const selectedTeam = data.filter((item) => item?.value === true).map((item) => item.id);
  const selectedTeamAgent = [];
  try {
    const TEAMS = LobTeamAgent;
    TEAMS.forEach((_ele) => {
      if (checkAvailability(selectedTeam, _ele.team)) {
        selectedTeamAgent.push(_ele);
      }
    });
  } catch (error) {
    console.error(error);
  }

  return selectedTeamAgent;
}
function selectedLobTeamByLobTeamDashbord(data, LobTeamAgent) {
  const selectedTeam = data.filter((item) => item?.value === true).map((item) => item.id);
  const selectedTeamAgent = [];
  try {
    const TEAMS = LobTeamAgent;
    TEAMS.forEach((_ele) => {
      if (checkAvailability(selectedTeam, _ele.team)) {
        selectedTeamAgent.push(_ele);
      }
    });
  } catch (error) {
    console.error(error);
  }
  return selectedTeamAgent;
}

function selectedLobTeamByLobTeamcallflow(data, LobTeamAgent) {
  console.log(data, 'bnbnbnbnb', LobTeamAgent);
  const selectedTeam = data.filter((item) => item?.status === true).map((item) => item.id);
  const selectedTeamAgent = [];
  try {
    const TEAMS = LobTeamAgent;
    TEAMS.forEach((_ele) => {
      if (checkAvailability(selectedTeam, _ele.team)) {
        selectedTeamAgent.push(_ele);
      }
    });
  } catch (error) {
    console.error(error);
  }

  return selectedTeamAgent;
}
export const getTeamList = async (store, selectedFilter) => {
  if (!selectedFilter.LOB) return;
  if (selectedFilter.LOB.length <= 0) return;

  try {
    const TEAMS = store.getState().filter.ScoreCardFilterConfigData.select_team.value;
    // const TEAMS = store.getState().filter.LOBTeam;
    // console.log(TEAMS, 'TEAMSss');
    store.dispatch(setLobTeamDataByLob(selectedLobTeamByLob(selectedFilter.LOB, TEAMS)));
  } catch (error) {
    console.error('error at getTeamList of middlware utils function');
  }
};

export const getAgentList = async (store, LOBTeam) => {
  // console.log('LOBTeamLOBTeam', LOBTeam);
  if (!LOBTeam) return;
  try {
    store.dispatch(
      setLOBTeamAgentDataByLobTeam(selectedLobTeamByLobTeam(LOBTeam, store.getState().filter.ScoreCardFilterConfigData.select_agent.value))
    );
    console.log('getAgentList', LOBTeam);
    // getScoreCardConfigData
  } catch (error) {
    console.error('error at getAgentList of middlware utils function');
  }
  // store.dispatch(getAgentBasedTeamData(teamList));
};

export const getTeamListAnalytics = async (store, selectedFilter) => {
  if (!selectedFilter.LOB) return;
  if (selectedFilter.LOB.length <= 0) return;

  try {
    const TEAMS = store.getState().analyticsfilter.AnalyticsConfigData?.select_team.value;
    const dataToDispatch = selectedLobTeamByLob(selectedFilter.LOB, TEAMS);
    store.dispatch(AnalyticsFilter.setLobTeamDataByLob(dataToDispatch));
  } catch (error) {
    console.log('error at getTeamListAnalytics of middlware utils function', error);
  }
};

export const getTeamListdashbord = async (store, selectedFilter) => {
  console.log(store, 'vimalchecks', selectedFilter);
  if (!selectedFilter.LOB) return;
  if (selectedFilter.LOB.length <= 0) return;

  try {
    const TEAMS = store.getState().dashbordFilter.DashbordFilterConfigData?.select_team.value;
    console.log(TEAMS, 'TEAMS');
    const dataToDispatch = selectedLobTeamByLob(selectedFilter.LOB, TEAMS);
    store.dispatch(DashbordFilter.setLobTeamDataByLob(dataToDispatch));
  } catch (error) {
    console.log('error at getTeamListAnalytics of middlware utils function', error);
  }
};
export const getAgentListdashbord = async (store, LOBTeam) => {
  // console.log('LOBTeamLOBTeam', LOBTeam);
  if (!LOBTeam) return;
  try {
    store.dispatch(
      DashbordFilter.setLOBTeamAgentDataByLobTeam(
        selectedLobTeamByLobTeamDashbord(LOBTeam, store.getState().dashbordFilter.DashbordFilterConfigData.select_agent.value)
      )
    );
  } catch (error) {
    console.error('error at getAgentList of middlware utils function');
  }
  // store.dispatch(getAgentBasedTeamData(teamList));
};
export const getTeamListcallFlow = async (store, selectedFilter) => {
  if (!selectedFilter.LOB) return;
  if (selectedFilter.LOB.length <= 0) return;

  try {
    const TEAMS = store.getState().callFlow.LOBTeam2;
    const dataToDispatch = selectedLobTeamByLobCallflow(selectedFilter.LOB, TEAMS);
    store.dispatch(CallFlow.setLobTeamDataByLob(dataToDispatch));
  } catch (error) {
    console.log('error at getTeamListAnalytics of middlware utils function', error);
  }
};

export const getAgentListAnalytics = async (store, LOBTeam) => {
  // if (!LOBTeam) return;
  // const selectedTeam = await LOBTeam.filter((item) => item?.value === true).map(
  //   (item) => item.id
  // );
  // const teamList = {
  //   team_list: selectedTeam,
  // };
  // store.dispatch(AnalyticsFilter.getAgentBasedTeamData(teamList));

  if (!LOBTeam) return;
  try {
    store.dispatch(
      AnalyticsFilter.setLOBTeamAgentDataByLobTeam(
        selectedLobTeamByLobTeam(LOBTeam, store.getState().analyticsfilter.AnalyticsConfigData.select_agent.value)
      )
    );
  } catch (error) {
    console.error('error at getAgentListAnalytics of middlware utils function');
  }
};
export const getAgentListCallflow = async (store, LOBTeam) => {
  // if (!LOBTeam) return;
  // const selectedTeam = await LOBTeam.filter((item) => item?.value === true).map(
  //   (item) => item.id
  // );
  // const teamList = {
  //   team_list: selectedTeam,
  // };
  // store.dispatch(AnalyticsFilter.getAgentBasedTeamData(teamList));
  if (!LOBTeam) return;
  console.log(store.getState()?.callFlow?.LOBTeamAgent2, 'vimalandchirag');
  try {
    // selectedLobTeamByLobTeamcallflow(LOBTeam, store?.getState()?.callflow?.LOBTeamAgent2);

    store.dispatch(
      CallFlow.setLOBTeamAgentDataByLobTeam(selectedLobTeamByLobTeamcallflow(LOBTeam, store?.getState()?.callFlow?.LOBTeamAgent2))
    );
  } catch (error) {
    console.error('error at getAgentListAnalytics of middlware utils function');
  }
};
// AnalyzeFilter;

export const getTeamListAnalyze = async (store, selectedFilter) => {
  if (!selectedFilter.LOB) return;
  if (selectedFilter.LOB.length <= 0) return;

  try {
    const TEAMS = store.getState().analyzefilter.InspectConfigData.select_team.value;
    const dataToDispatch = selectedLobTeamByLob(selectedFilter.LOB, TEAMS);
    store.dispatch(AnalyzeFilter.setLobTeamDataByLob(dataToDispatch));
  } catch (error) {
    console.error('error at getTeamListAnalyze of middlware utils function', error);
  }
};

export const getAgentListAnalyze = async (store, LOBTeam) => {
  // if (!LOBTeam) return;
  // const selectedTeam = await LOBTeam.filter((item) => item?.value === true).map(
  //   (item) => item.id
  // );
  // const teamList = {
  //   team_list: selectedTeam,
  // };
  // store.dispatch(AnalyzeFilter.getAgentBasedTeamData(teamList));
  if (!LOBTeam) return;
  try {
    store.dispatch(
      AnalyzeFilter.setLOBTeamAgentDataByLobTeam(
        selectedLobTeamByLobTeam(LOBTeam, store.getState().analyzefilter.InspectConfigData.select_agent.value)
      )
    );
  } catch (error) {
    console.error('error at getAgentListAnalyze of middlware utils function');
  }
};

// EvalutionFilter

export const getTeamListEvalution = async (store, selectedFilter) => {
  // console.log(selectedFilter, 'TEAMS');
  if (!selectedFilter.LOB) return;
  if (selectedFilter.LOB.length <= 0) return;
  try {
    // const TEAMS = store.getState().evaluationfilter.EvaluationFilterConfigData.select_team.value;
    const TEAMS = store.getState().evaluationfilter.EvaluationFilterConfigData?.select_team.value;
    const dataToDispatch = selectedLobTeamByLob(selectedFilter.LOB, TEAMS);
    store.dispatch(EvalutionFilter.setLobTeamDataByLob(dataToDispatch));
    // store.dispatch(EvalutionFilter.setLobTeamDataByLob(selectedLobTeamByLob(selectedFilter.LOB, TEAMS)));
  } catch (error) {
    console.error('error at getTeamListEvalution of middlware utils function');
  }
};

export const getAgentListEvalution = async (store, LOBTeam) => {
  // if (!LOBTeam) return;
  // const selectedTeam = await LOBTeam.filter((item) => item?.value === true).map(
  //   (item) => item.id
  // );
  // const teamList = {
  //   team_list: selectedTeam,
  // };
  // store.dispatch(EvalutionFilter.getAgentBasedTeamData(teamList));
  if (!LOBTeam) return;
  try {
    store.dispatch(
      EvalutionFilter.setLOBTeamAgentDataByLobTeam(
        selectedLobTeamByLobTeam(LOBTeam, store.getState().evaluationfilter.EvaluationFilterConfigData.select_agent.value)
      )
    );
  } catch (error) {
    console.error('error at getAgentListEvalution of middlware utils function');
  }
};

export const additionalFields = async (store, payload) => {
  // if (!payload) return;
  console.log('additionalFields', payload);
  store.dispatch(setFieldsData(payload || null));
};

export function objectWithNew(old, value) {
  let newOutfit = Object.assign({}, old, {
    ...value
  });

  return newOutfit;
}

export function isEmpty(value) {
  return value && Object.keys(value).length === 0 && value.constructor === Object;
}

export const generateDefaultLobTeamAgentAsSelected = (data) => {
  const { select_lob, select_team, select_agent } = data;
  const LOB = select_lob?.value || null;
  const LOBTeam = !LOB ? select_team?.value : null;
  const LOBTeamAgent = !LOB && !LOBTeam ? select_agent?.value : null;

  return {
    LOB: LOB || [],
    // LOB: selectedLOB,
    LOBTeam: LOBTeam || [],
    LOBTeamAgent: LOBTeamAgent || []
    // selectedLOB,
    // selectedLOBTeam,
    // selectedLOBTeamAgent,
  };
};

export const getDataFromStore = (store) => {
  const page = store.getState().managment.totalpage;
  const index = store.getState().managment.pageindex;
  const search = '';
  const obj = { search: search, pageindex: index, totalpage: page };
  return obj;
};
export const getDataFromUserStore = (store) => {
  const userpage = store.getState().managment.Usertotalpage;
  const userindex = store.getState().managment.Userpageindex;
  const usersearch = '';
  const userobj = {
    search: usersearch,
    pageindex: userindex,
    totalpage: userpage
  };
  return userobj;
};
export const getDataFromCategoryStore = (store, item) => {
  const categorypage = store.getState().sopCategory.totalpage;
  const categoryindex = store.getState().sopCategory.pageindex;
  const pagename = store.getState().sopCategory.pagename;
  const categorysearch = ' ';
  const categoryobj = {
    search: categorysearch,
    pageindex: categoryindex,
    totalpage: categorypage
  };
  const categoryviewobj = {
    search: categorysearch,
    pageindex: categoryindex,
    totalpage: categorypage,
    name: pagename
  };
  if (item === 'Category') {
    return categoryobj;
  } else {
    return categoryviewobj;
  }
};

export const generateTranscriptionFromAPI = (incomingData) => {
  const result = [];
  if (incomingData) {
    incomingData.map((_el) => {
      const { type, data } = _el;

      const { callContentID, message } = data;
      if (type === WSS_EVENTS_FOR_QP.CALL_CONTENT) {
        result.push(message);
      } else {
        const indexOfCallContent = result.findIndex((el) => el.id === callContentID);
        console.log('indexOfCallContent', indexOfCallContent);
        if (indexOfCallContent > -1) {
          result[indexOfCallContent] = {
            ...result[indexOfCallContent],
            intent: message?.intent || result[indexOfCallContent]?.intent,
            sentiment: message?.sentiment || result[indexOfCallContent]?.sentiment,
            avg_sentiment: message?.avg_sentiment || result[indexOfCallContent]?.avg_sentiment
          };
        }
      }
    });
  }
  return result.reverse();
};

export function sortByPriorityIndex(obj) {
  const sortedKeys = Object.keys(obj).sort((a, b) => {
    return obj[a].priority_index - obj[b].priority_index;
  });

  const sortedObject = {};

  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });

  return sortedObject;
}
export function sortByPriorityIndexSetting(obj) {
  const sortedKeys = Object.keys(obj).sort((a, b) => {
    return obj[a].index - obj[b].index;
  });
  const sortedObject = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = obj[key];
  });
  return sortedObject;
}

export const getkeyName = (obj) => {
  if (obj) {
    let array = ['All'];
    const keys = Object.keys(obj);
    for (const key of keys) {
      array.push(key);
    }
    return array;
  }
};

export const fetchdata = (SelectedTab, tabs) => {
  if (tabs) {
    if (SelectedTab === 'All') {
      return tabs;
    } else {
      const selectedPair = { [SelectedTab]: tabs[SelectedTab] };
      return selectedPair;
    }
  }
};

export function objectToArray(obj) {
  const result = [];

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const item = obj[key];
      const slug = key;
      if (item.default_value) {
        item.selected = item.default_value;
      }
      result.push({ slug, ...item });
    }
  }

  return result;
}
export function objectToArray2(obj) {
  const result = [];

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const item = obj[key];
      const slug = key;

      item.selected = null;

      result.push({ slug, ...item });
    }
  }

  return result;
}
export const GetLobadata = (data, ScoreCardFilterConfigData) => {
  if (data.Team === undefined || data.Team) {
    const selected = ScoreCardFilterConfigData.select_team.value.filter((value) =>
      value.name === data?.Team ? data.Team : GetTeamadata(data, ScoreCardFilterConfigData)
    );
    const teamArrays = selected.map((_el) => _el.lob);
    const [myNumber] = teamArrays;
    const matchingItem = ScoreCardFilterConfigData.select_lob.value.find((value) => value.id === myNumber);
    const matchingName = matchingItem?.name;
    return matchingName;
  }
};

export const GetTeamadata = (data, ScoreCardFilterConfigData) => {
  if (data.Agent) {
    const selected = ScoreCardFilterConfigData.select_agent.value.filter((value) => value.username === data.Agent);
    const teamArrays = selected.map((_el) => _el.team);
    const names = teamArrays.map((teamArray) => teamArray.map((team) => team.name));
    const namesString = names.flat().join(', ');
    return namesString;
  }
};
export const convertdataDashbordfilter = (data, objectToArray, sortByPriorityIndex, store, setFieldsData) => {
  console.log('helllo', data);
  if (data) {
    let extra_filter = {};
    if (data.advancefilter) {
      for (const key in data.advancefilter.features_data) {
        extra_filter[key] = {
          slug: key,
          ...data.advancefilter.features_data[key]
        };
      }

      extra_filter = sortByPriorityIndex(extra_filter);
    } else {
      extra_filter = null;
    }
    let feature_filter = {};
    let fields = {};
    if (data.addcolumn) {
      for (const key in data?.addcolumn?.features_data) {
        fields[key] = objectToArray(data?.addcolumn?.features_data[key]);
        //     slug: key,
        //     ...data?.addcolumn?.features_data[key]
        // };
      }
      // fields = data?.addcolumn?.features_data;
      store.dispatch(setFieldsData(fields));
    } else {
      fields = null;
    }
    // let tabledata = {};
    // if (data.datagrid) {
    //   for (const key in data.datagrid.features_data) {
    //     tabledata[key] = {
    //       ...data.datagrid.features_data[key]
    //     };
    //   }
    // } else {
    //   feature_filter = null;
    // }
    return {
      ...data,
      data: {
        extra_filter: extra_filter,
        feature_filter: feature_filter
        // table_data: [tabledata]
      }
    };
  } else {
    return null;
  }
};
export const GetRowFilterDataIds = (data, ScoreCardFilterConfigData) => {
  let lob = [];
  let team = [];
  let agent = [];
  if (data.Agent) {
    const selected = ScoreCardFilterConfigData.select_agent?.value?.filter((value) => value?.username === data.Agent);
    agent = selected;
    // console.log('GetLobadataIds Agent', agent);
    return {
      select_lob: agent[0].team[0].lob,
      select_team: agent[0].team[0].id,
      select_agent: agent[0].id
    };
  }
  if (data.Team) {
    const selected = ScoreCardFilterConfigData?.select_team?.value?.filter((value) => value?.name === data?.Team);
    team = selected;
    // console.log('GetLobadataIds Team', team);
    return {
      select_lob: team[0]?.lob,
      select_team: team[0]?.id,
      select_agent: null
    };
  }
  if (data.Lob) {
    const selected = ScoreCardFilterConfigData?.select_lob?.value?.filter((value) => value?.name === data?.Lob);
    lob = selected;
    console.log('GetLobadataIds Lob', ScoreCardFilterConfigData, data);
    return {
      select_lob: lob?.[0]?.id,
      select_team: null,
      select_agent: null
    };
  }
};

export const getAgentListDataByIds = (teamIds, LobTeamAgent) => {
  const selectedTeam = teamIds;
  const selectedTeamAgent = [];
  try {
    const TEAMS = LobTeamAgent;
    TEAMS.forEach((_ele) => {
      if (checkAvailability(selectedTeam, _ele.team)) {
        selectedTeamAgent.push(_ele);
      }
    });
  } catch (error) {
    console.error(error);
  }

  return selectedTeamAgent;
};

export const getTeamListDataByIds = (LobIds, LobTeam) => {
  const selectedLOB = LobIds;
  const selectedTeam = [];
  try {
    const TEAMS = LobTeam;
    TEAMS.forEach((_ele) => {
      if (selectedLOB.includes(_ele.lob)) {
        selectedTeam.push(_ele);
      }
    });
  } catch (error) {
    console.error(error);
  }
  return selectedTeam;
};
